// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pixel-manager-mf .v-application--is-ltr .v-text-field .v-input__append-inner{margin-left:8px!important;margin-top:auto!important;margin-bottom:auto!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
